//import { Tracker } from 'meteor/tracker';
import SimpleSchema from 'simpl-schema';

const schema = new SimpleSchema({
  phoneNumber: {
    type: String,
    regEx: SimpleSchema.RegEx.Phone,
    min: 10,
    max: 10,
    label: 'Number',
  },
  phoneType: {
    type: String,
    min: 1,
    label: 'Type',
  },
});

export default schema;
